import { ApplicationApiTagTypes, ApplicationApiUrls } from "@/modules/application/common/enum";
import type {
  ICreatePayrollCardOpeningApplicationRequest,
  IPayrollCardOpeningApplication,
  IUpdatePayrollCardOpeningApplicationRequest,
} from "@/modules/application/common/types";
import { withIdempotency } from "@/shared/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "app/axios";

export const payrollCardOpeningApplicationApi = createApi({
  reducerPath: "payrollCardOpeningApplicationApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: [ApplicationApiTagTypes.ApplicationHistory],
  endpoints: (builder) => ({
    createPayrollCardOpeningApplication: builder.mutation<string, ICreatePayrollCardOpeningApplicationRequest>(
      withIdempotency<ICreatePayrollCardOpeningApplicationRequest>(
        ApplicationApiUrls.PayrollCardOpening
      )),
    updatePayrollCardOpeningApplication: builder.mutation<string, IUpdatePayrollCardOpeningApplicationRequest>(
      {
        query: ({ data, id }) => ({
          url: `${ApplicationApiUrls.PayrollCardOpening}/${id}`,
          method: "PUT",
          data,
        }),
      }),
    getPayrollCardOpeningApplication: builder.query<IPayrollCardOpeningApplication, {
      id: string
    }>({
      query: ({ id }) => ({
        url: `${ApplicationApiUrls.PayrollCardOpening}/${id}`,
      }),
    }),
  }),
});

export const {
  useGetPayrollCardOpeningApplicationQuery,
  useCreatePayrollCardOpeningApplicationMutation,
  useUpdatePayrollCardOpeningApplicationMutation,
} = payrollCardOpeningApplicationApi;
